import React from 'react';
import { Link } from 'react-router-dom';
import Footer from './Footer';

const PrayerRequestSubmitted = () => {
  return (
    <div className="stt-page">
      <div className="stt-content" style={{ paddingTop: '60px', paddingBottom: '60px' }}>
        <div className="stt-confirmation-block">
          <h2 className="stt-confirmation-title">Your request has been received with care.</h2>
          <p className="stt-confirmation-text">We will be praying for you.</p>
          <blockquote className="stt-confirmation-quote">
            "Pray, hope, and don't worry… God is merciful and will hear your prayer."
            <cite>— St. Padre Pio</cite>
          </blockquote>
          <div className="stt-confirmation-actions">
            <Link to="/" className="btn stt-btn-primary">Return Home</Link>
            <Link to="/prayer-request" className="btn stt-btn-outline">+ Another Prayer</Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrayerRequestSubmitted;
